import * as React from 'react';
import { SVGProps } from 'react';
export const CaretUpIcon = (props: SVGProps<SVGSVGElement>) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props} data-sentry-element="svg" data-sentry-component="CaretUpIcon" data-sentry-source-file="CaretUp.tsx">
    <path d="m17 14-5-6-5 6h10Z" fill={props.fill || `currentColor`} data-sentry-element="path" data-sentry-source-file="CaretUp.tsx" />
  </svg>;